import { sendForm } from './sendForm';

window.form = function (data) {
	return {
		formSent: null,
		formLoading: false,
		disabeld: true,

		resolveInteractions: {
			['@disable-submit.window'](event) {
				this.disabled = true;
			},
		},

		async submitForm() {
			const form = this.$root;
			const formData = new FormData(form);

			if ( ! formData.get('action') ) {
				formData.append('action', 'sendContactForm');
			}

			gtmDataLayer({event: 'form_sent', form: formData.get('form')?? null});

			this.formLoading = true;

			const response = await sendForm(formData);

			if ( response.success ) {
				console.log(response);
				this.formSent = {
					success: true,
					message: response.data.message,
				};
				this.formLoading = false;

				this.$root.reset();
			} else {
				this.formLoading = false;
				this.formSent = {
					success: false,
					message: response.data.message || __('An error occurred. Please try again.', 'theme'),
				};
			}
		},

		init() {
			this.formElements = this.$root.querySelectorAll('[required]');

			let validFieldsCount = 0;
			this.formElements.forEach(element => {
				element.addEventListener("input", (e) => {
					const parent = e.target.closest('.form-row');

					if (!parent) return;

					if (e.target.validity.valid) {
						parent.classList.remove('invalid');
						const error = parent.getElementsByClassName('error')[0];
						if (error) {
							error.parentNode.removeChild(error);
						}
						validFieldsCount++;
					} else {
						parent.classList.add('invalid');
						validFieldsCount--;
					}
				});
			});
		}
	}
}


document.addEventListener('invalid', function(e) {
    const parentRow = e.target.closest('.form-row');

    if (parentRow) {
        if (!parentRow.classList.contains('invalid')) {
            parentRow.classList.add('invalid');
            parentRow.insertAdjacentHTML("beforeend", '<span class="error">' + e.target.validationMessage + '</span>');
        }
    }

    const form = e.target.closest("form");

    if (form && !form.classList.contains('invalid')) {
        form.classList.add('invalid');
    }
}, true);


function gtmDataLayer(data) {
	if ( typeof dataLayer != "undefined" ) {
		dataLayer.push({data})
	}
}
